import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honey = (formData.get('phone_alt') as string || '').trim();
    if (honey) {
      setStatus('success');
      setEmail('');
      return;
    }

    setStatus('loading');
    try {
      const res = await fetch('https://readdy.ai/api/form/d9qo8vsnlsngrm4lm2q0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          email: formData.get('email') as string,
        }).toString(),
      });
      const text = await res.text();
      let parsed: any = {};
      try { parsed = JSON.parse(text); } catch (_err) { /* ignore parse error */ }
      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const msg = parsed?.meta?.message || parsed?.message || '提交失败，请稍后再试';
        setErrorMsg(msg);
        setStatus('error');
      }
    } catch {
      setErrorMsg('网络错误，请检查网络连接');
      setStatus('error');
    }
  };

  return (
    <section id="newsletter" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-50 text-primary-600 mb-6">
            <i className="ri-mail-send-line text-2xl"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            订阅福利资讯
          </h2>
          <p className="text-sm text-foreground-500 mb-8 leading-relaxed">
            每周精选福利汇总，第一时间获取最新折扣、补贴和权益信息。
            我们承诺不发送垃圾邮件，您可以随时取消订阅。
          </p>

          {status === 'success' ? (
            <div className="py-4 px-6 rounded-lg bg-primary-50 text-primary-700 text-sm">
              <i className="ri-checkbox-circle-line mr-2"></i>
              订阅成功！请查收确认邮件，感谢您的关注。
            </div>
          ) : (
            <form
              onSubmit={handleSubmit}
              data-readdy-form=""
              className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
            >
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="请输入您的电子邮箱"
                required
                className="flex-1 px-4 py-3 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
              />
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="form-honey"
              />
              <button
                type="submit"
                disabled={status === 'loading'}
                className="px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors disabled:opacity-60 whitespace-nowrap cursor-pointer"
              >
                {status === 'loading' ? '提交中...' : '立即订阅'}
              </button>
            </form>
          )}

          {status === 'error' && (
            <p className="mt-3 text-xs text-accent-600">{errorMsg}</p>
          )}

          <p className="mt-4 text-xs text-foreground-400">
            已有{' '}
            <strong className="text-foreground-600">12,580</strong> 位用户订阅
          </p>
        </div>
      </div>
    </section>
  );
}